<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <DatePicker class="search-ipt" :value="searchIpt.beginDate" format="yyyy-MM-dd" @on-change="getCommonBeginDate" placeholder="请输入开始时间"></DatePicker>
            <DatePicker class="search-ipt" :value="searchIpt.endDate" format="yyyy-MM-dd" @on-change="getCommonEndDate" placeholder="请输入结束时间"></DatePicker>
            <Input class="search-ipt" type="text" v-model="searchIpt.publisher" placeholder="请输入发布者姓名" @on-enter="getNoticeList" clearable/>
            <Button type="primary" icon="md-search" class="search_tn" data-level="common" @click="getNoticeList">搜索</Button>
            <Button class="top_search_btn" type="primary" ghost icon="ios-funnel" @click="topSearchStatus = true">高级搜索
            </Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row,index }" slot="publisherName">
          <div class="jump_color" @click="toUserList(row.publisherName)">{{row.publisherName}}</div>
        </template>
        <template slot-scope="{ row, index }" slot="schoolName">
          <div class="jump_color" @click="toSchoolDetail(row.schoolId)">{{row.schoolName}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="className">
          <div class="jump_color" @click="toKlassDeTail(row.classId)">{{row.classGrade + row.className}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="type">
          <span v-if="row.type === 1">无需响应</span>
          <span v-if="row.type === 2">需确认</span>
          <span v-if="row.type === 3">需回复</span>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <div class="jump_color"  @click="checkDetail(row.id)">详情</div>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getNoticeList"></paging>
    <Modal class="top_search_modal" v-model="topSearchStatus" title="高级搜索">
      <div class="top_search_wrapper">
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.title" placeholder="请输入标题关键字" clearable/>
        <Select class="search_item" v-model="searchIpt.type" clearable>
          <Option v-for="item in noticeType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
        <div class="search_time search_item">
          <DatePicker class="time" :value="searchIpt.seniorBeginDate" format="yyyy-MM-dd" @on-change="getBeginDate" placeholder="请输入开始时间"></DatePicker>
          <DatePicker class="time" :value="searchIpt.seniorEndDate" format="yyyy-MM-dd" @on-change="getEndDate" placeholder="请输入结束时间"></DatePicker>
        </div>
        <!--<Cascader class="search-ipt search_item" :data="regionList" change-on-select placeholder="请选择地区"></Cascader>-->
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.schoolAddress" placeholder="请输入学校地址" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.schoolName" placeholder="请输入学校名称" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.classId" placeholder="请输入班级ID" clearable/>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="topSearchStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" icon="md-search" @click="topSearchFn">搜索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {dealDate} from '../common/common';
  import {_getNoticeList} from '../api/api';
  import paging from '../templates/Paging.vue';
  export default {
    name:"Notices",
    components: {paging},
    data() {
      return {
        pageSize: 10, // 每页条数
        totalNum: 0, // 数据总条数
        searchLevel: 'common',// common普通搜索，senior高级搜索
        topSearchStatus:false, // 高级搜索显示状态
        tableData:[],
        searchIpt: {
          beginDate: '',
          endDate:'',
          publisher: '',
          seniorBeginDate: '',
          seniorEndDate: '',
          seniorPublisher: '',
          classId:'',
          schoolAddress: '',
          schoolName:'',
          title: '',
          type: 0,
        },
        noticeType: [
          {
            value: 1,
            label: '无需响应'
          },
          {
            value: 2,
            label: '需确认'
          },
          {
            value: 3,
            label: '需回复'
          },
        ],
        tableHeader: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '通知标题',
            key:'title'
          },
          {
            title: '发布者',
            key:'publisherName',
            slot: 'publisherName'
          },
          {
            title: '学校',
            key:'schoolName',
            slot:'schoolName'
          },
          {
            title: '班级名称',
            key:'className',
            slot:'className'
          },
          {
            title: '发布时间',
            key:'publishTime',
            sortable:true,
            width: 150
          },
          {
            title: '通知类型',
            key:'type',
            slot: 'type',
            width: 112,
            filters:[
              {
                label: '无需响应',
                value: 1
              },
              {
                label: '需确认',
                value: 2
              },
              {
                label: '需回复',
                value: 3
              },
            ],
            filterMethod(value,row) {
              return row.type.toString().indexOf(value) > -1;
            }
          },
          {
            title: '操作',
            key:'action',
            slot:'action'
          },
        ],
        regionList: [
          {
            value: 'beijing',
            label: '北京',
            children: [
              {
                value: 'gugong',
                label: '故宫'
              },
              {
                value: 'tiantan',
                label: '天坛'
              },
              {
                value: 'wangfujing',
                label: '王府井'
              }
            ]
          },
          {
            value: 'jiangsu',
            label: '江苏',
            children: [
              {
                value: 'nanjing',
                label: '南京',
                children: [
                  {
                    value: 'fuzimiao',
                    label: '夫子庙',
                  }
                ]
              },
              {
                value: 'suzhou',
                label: '苏州',
                children: [
                  {
                    value: 'zhuozhengyuan',
                    label: '拙政园',
                  },
                  {
                    value: 'shizilin',
                    label: '狮子林',
                  }
                ]
              }
            ],
          }
        ]
      }
    },
    methods: {
//      获取通知列表
      getNoticeList(msg){
        const self = this;
        let params = {
          beginDate: self.searchLevel === 'common' ? (self.searchIpt.beginDate&&parseInt(self.searchIpt.beginDate.toString().split('-').join(''))) : (self.searchIpt.seniorBeginDate&&parseInt(self.searchIpt.seniorBeginDate.toString().split('-').join(''))),
          endDate:self.searchLevel === 'common' ? (self.searchIpt.endDate&&parseInt(self.searchIpt.endDate.toString().split('-').join(''))) : (self.searchIpt.seniorEndDate&&parseInt(self.searchIpt.seniorEndDate.toString().split('-').join(''))),
          publisher: self.searchLevel === 'common' ? (self.searchIpt.publisher) : (self.searchIpt.seniorPublisher),
          classId:self.searchIpt.classId,
          schoolAddress: self.searchIpt.schoolAddress,
          schoolName:self.searchIpt.schoolName,
          title: self.searchIpt.title,
          type: self.searchIpt.type,
          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize,
          sort: 'createTime,desc'
        };
        _getNoticeList({params:params}).then(res => {
          if(res.code === 0) {
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
            self.tableData.length && self.tableData.forEach(item => {
              item.publishTime = dealDate(item.publishTime);
            })
          }
        })
      },
      //      获取高级搜索的开始时间
      getBeginDate(res) {
        this.searchIpt.seniorBeginDate =res;
      },
//      获取高级搜索的结束时间
      getEndDate(res){
        this.searchIpt.seniorEndDate =res;
      },
      //      获取搜索的开始时间
      getCommonBeginDate(res) {
        console.log("beginDate",res);
        this.searchIpt.beginDate =res;
      },
//      获取搜索的结束时间
      getCommonEndDate(res){
        console.log("endDate",res);
        this.searchIpt.endDate =res;
      },
//      高级搜索
      topSearchFn() {
        this.searchLevel = "senior";
        this.getNoticeList();
        this.searchIpt = {
          seniorBeginDate: '',
          seniorEndDate: '',
          seniorPublisher: '',
          classId:'',
          schoolAddress: '',
          schoolName:'',
          title: '',
          type: 0,
        };
        this.topSearchStatus = false;
      },
//      跳转到学校列表
      toSchoolDetail(schoolId) {
        this.$router.push(`/schools?id=${schoolId}`)
      },
//      跳转到用户列表
      toUserList(publisherName){
        this.$router.push(`/user?name=${encodeURIComponent(publisherName)}`)
      },
//      跳转到班级详情
      toKlassDeTail(classId) {
        this.$router.push(`/klasses/detail?id=${classId}`)
      },
//      通知详情
      checkDetail(id) {
        this.$router.push(`/notices/detail?id=${id}`);
      }
    },
    mounted() {
      this.getNoticeList();
    },
    created() {
      if(this.$route.query.classId) {
        this.searchIpt.classId = this.$route.query.classId;
      }
    }
  };
</script>
<style>
/*.search_time .time{*/
  /*width: 49%;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/Notices.vue